import classNames from 'classnames';
import React, { Component, createRef, HTMLAttributes, RefObject } from 'react';
import { ResizeObserver } from 'resize-observer';
import { applyTextEllipsisOnResize } from '../plugins/text-ellipsis';

interface IProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  clump?: number;
  observe: boolean;

  // if true ellipsis will not calculated
  pretend?: boolean;
}

export default class TextEllipsis extends Component<IProps> {
  static defaultProps = {
    observe: true,
    pretend: false,
  };

  private $el: RefObject<HTMLDivElement> = createRef();
  private observer: ResizeObserver;

  applyEllipsis() {
    if (!this.$el.current || this.props.pretend) {
      return;
    }
    this.observer = applyTextEllipsisOnResize([this.$el.current], 2, true);
  }

  shouldComponentUpdate(
    nextProps: Readonly<IProps>,
    _nextState: Readonly<Record<any, any>>,
    _nextContext: any,
  ): boolean {
    return nextProps.children !== this.props.children;
  }

  componentDidMount(): void {
    this.applyEllipsis();
  }

  componentDidUpdate(
    prevProps: Readonly<{ children: React.ReactNode; className?: string }>,
    _prevState: Readonly<Record<any, any>>,
    _snapshot?: any,
  ): void {
    if (prevProps.children !== this.props.children && this.$el.current) {
      this.applyEllipsis();
    }
  }

  componentWillUnmount(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  render() {
    const { className, clump, children, observe, pretend, ...htmlAttr } =
      this.props;
    return (
      <div
        {...htmlAttr}
        ref={this.$el}
        data-clump={clump || 2}
        className={classNames(!pretend && 'eb-js-ellipsis', className)}
      >
        {typeof children === 'string' ? <span>{children}</span> : children}
      </div>
    );
  }
}
